import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  connect() {
    const modal = document.getElementById('news-banner-modal');
    const stickyFooter = document.querySelector('[data-navigation-target="stickyFooter"]');

    if (!modal || !stickyFooter) return;

    this.observer = new MutationObserver(() => {
      const isModalHidden = modal.classList.contains('hidden');
      this.toggleFooterZIndex(stickyFooter, isModalHidden);
    });

    this.observer.observe(modal, { attributes: true, attributeFilter: ['class'] });
  }

  disconnect() {
    this.observer?.disconnect();
  }

  toggleFooterZIndex(element, isModalHidden) {
    element.classList.toggle('z-50', isModalHidden);
    element.classList.toggle('z-40', !isModalHidden);
  }
}
